import { getScrollParent } from './helpers';

export class ClickRevealSearch {
	/**
	 * Initialize the form.
	 *
	 * @param {node} form The search form element.
	 * @param {node} container The containing element that should get a class applied to it when the form is opened.
	 */
	constructor({ form, container }) {
		this.form = form;
		this.container = container || document.documentElement;
		if (this.form && this.container) {
			this.input = this.form.querySelector('.search-field');
			this.scrollParent = getScrollParent(this.form);

			document.addEventListener('click', this.closeForm);
			this.form.addEventListener('click', this.openForm);
			this.input.addEventListener('invalid', this.handleInvalid);
		}
	}

	closeForm = () => {
		this.form.classList.remove('open');
		this.input.value = '';
		this.container.classList.remove('search-is-open');
	}

	openForm = (e) => {
		e.stopPropagation();
		this.form.classList.add('open');
		this.container.classList.add('search-is-open');
	}

	/**
	 * Scroll to the top of the form's scroll parent when invalid.
	 */
	handleInvalid = () => {
		if (this.scrollParent) {
			this.scrollParent.scrollTop = this.scrollParent.scrollHeight;
		}
	}
}

// eslint-disable-next-line no-unused-vars
const headerSearch = new ClickRevealSearch({
	form: document.querySelector('.site-header .search-form'),
	container: document.querySelector('.site-header'),
});
